import { Component, ChangeDetectorRef, HostBinding } from '@angular/core';
import { ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { LoginComponent } from './login/login.component';
import { AuthService } from './shared';
import { LOCALE_ID, Inject } from '@angular/core';
import { Angulartics2GoogleAnalytics } from 'angulartics2/ga';
import { DialogService } from './dialogs/services/dialog.service';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { SystemService } from './shared/system.service';
import { AboutComponent } from './planner/about/about.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  lastCloseResult: string;

  @ViewChild(MatSidenav, { static: true }) _sideNav: MatSidenav;

  constructor(
    @Inject(LOCALE_ID)
    private locale: string,
    private dialog: DialogService,
    angulartics2GoogleAnalytics: Angulartics2GoogleAnalytics,
    public auth: AuthService,
    public system: SystemService,
    private router: Router,
    private cd: ChangeDetectorRef
  ) {
    angulartics2GoogleAnalytics.startTracking();
  }

  initConfig = this.system.initConfig;

  appName() {
    return this.system.config.applicationName || 'WebPlanner';
  }

  get isEnglish() {
    return this.locale === 'en-US';
  }

  get canLogin() {
    return !this.auth.userId && (this.auth.publicMode || this.router.url !== '/');
  }

  loginClick() {
    this.dialog.open(LoginComponent);
  }

  logoutClick() {
    if (this.auth.roles && this.auth.roles.includes('seller')) {
      this.auth.loginAs(-1).subscribe(
        _ => this.cd.markForCheck(),
        e => this.auth.logout()
      );
    } else {
      this.auth.logout();
    }
  }

  storeMode$ = this.auth.isAuthenticated.pipe(
    map(v => v && this.auth.roles.includes('store'))
  );

  get userName() {
    return this.auth.roles.includes("seller") ? this.auth.fullName : this.auth.userName;
  }

  about() {
    this.dialog.open(AboutComponent);
  }
}
